<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->
<div class="k-overlay" *ngIf="editWinOpen"></div>
<div class="k-overlay" *ngIf="addWinOpen"></div>

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'user-tag']"></fa-icon> User Stories
        </h3>
      </div>

      <div class="bg-light p-2 rounded-lg rounded-2">
        <form class="k-form-horizontal">
          <div class="row g-3 align-items-center">
            <div class="col-4 k-form-field">
              <label for="user" class="form-label col-1 k-label">User</label>
              <div style="width: 100%;">
                <kendo-dropdownlist [data]="users" [(value)]="currentUser" textField="user_label" valueField="id"
                  (valueChange)="userValueChange($event)"></kendo-dropdownlist>
              </div>
            </div>
            <!-- <div class="col-4 k-form-field">
              <label for="user" class="form-label col-1 k-label">Stories</label>
              <div style="width: 100%;">
                <kendo-dropdownlist [data]="storyOptions" [(value)]="storyOption" textField="text" valueField="value"
                  (valueChange)="storyOptionChange($event)"></kendo-dropdownlist>
              </div>
            </div> -->
          </div>
          <!-- <div class="row g-3 align-items-center">
            <div class="col-4 k-form-field" style="margin-top: 20px;">
              <label for="search" class="form-label col-1 k-label">Search</label>
              <div style="width: 100%;">
                <input type="text" id="search" name="search" [(ngModel)]="searchStr" style="width: 70%;">
                <button class="btn btn-primary" (click)="doSearch()" style="margin-left: 10px;">Search</button>
              </div>
            </div>
          </div> -->
        </form>
        <casi-searcher [showProjects]="true" [projects]="projects" [projectLabels]="projectLabels" [users]="users"
          [storyEstimates]="storyEstimates" [storyPriorities]="storyPriorities" [storyTypes]="storyTypes"
          (onSearch)="onSearch($event)" [searchOptions]="searchOptions"></casi-searcher>

      </div>

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
        [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
        style="height: calc(100vh - 230px); min-height: 400px;" [pageSize]="pageSize" [pageable]="{
            buttonCount: 5,
            pageSizes: pageSizes,
            previousNext: true
          }">


        <ng-template kendoGridToolbarTemplate position="top">
          <button (click)="showAddWindow(windowTitleBar)" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add User Story
          </button>
        </ng-template>


        <kendo-grid-column title="Edit" [width]="70" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onEditClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="History" [width]="80" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onViewHistoryClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="timeline"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="id" title="Id" [width]="170" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-buttongroup selection="single">
              <button kendoButton title="Copy this story's link to your clipboard" (click)="copyLink(dataItem)">
                <fa-icon class="fa-solid fa-duotone " [icon]="['fad', 'link']"></fa-icon>
              </button>
              <button kendoButton title="Copy this story's ID to your clipboard" (click)="copyStoryID(dataItem.id)">
                {{dataItem.id}}
              </button>
            </kendo-buttongroup>
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field, true)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="title" title="Title" [width]="260" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [innerHTML]="formatText(dataItem.title)"></div>
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="project_name" title="Project" [width]="170" [style]="vTop">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="140" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div
              [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
              , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1
              , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
              , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
              {{dataItem.user_story_priority_description}}
            </div>
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="user_story_status_description" title="Status" [width]="160" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span
              [ngStyle]="{'color': dataItem.user_story_status_description?.toLowerCase() == 'accepted' ? 'green' :
              dataItem.user_story_status_description?.toLowerCase() == 'rejected' ? 'red' :
              dataItem.user_story_status_description?.toLowerCase() == 'finished' || dataItem.user_story_status_description?.toLowerCase() == 'delivered' ? 'blue' : ''}">
              {{dataItem.user_story_status_description}}
            </span>
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="owned_by_users" title="Owners" [width]="170" [style]="vTop">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="requested_by_user" title="Requested By" [width]="170" [style]="vTop">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="createdAt" title="Requested On" [width]="170" [style]="vTop">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.createdAt | date: 'dd/MM/yyyy HH:mm'}}
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field, true)" [includeTime]="true"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoGridDetailTemplate let-dataItem>

          <section>
            <p style="padding: 15px; background-color: cornsilk; font-weight:bold;"
              [innerHTML]="dataItem.description | safeHtml">
            </p>

          </section>

        </ng-template>

        <!-- <kendo-grid-column field="action" title="Action">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column> -->

        <!-- <kendo-grid-column title="Delete" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column> -->

        <!-- <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template> -->

      </kendo-grid>

    </div>
  </div>


</div>
<!--
<kendo-window *ngIf="editWinOpen" (close)="close()" [width]="1000">
  <kendo-window-titlebar>
    <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
      </span> Edit User Story / Comments </span>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <casi-user-story class="product" [showProjects]="true" [projects]="projects" [storyStatuses]="storyStatus"
    [selectedUserStoryId]="selectedUserStoryId" [storyTypes]="storyTypes" [storyPriorities]="storyPriorities"
    [storyEstimates]="storyEstimates" [users]="users" [modUsers]="projectUsers" [projectLabels]="projectLabels"
    [userStory]="selectedUserStory" (refresh)="doRefresh()" (closeForm)="close()">
  </casi-user-story>
</kendo-window> -->


<div kendoWindowContainer></div>
